<template>
    <modal id="reserve-same-appointment" :show-close="false" size="lg" class="text-center">
        <div class="title-sm">Reservation expired</div>

        <div class="pt-4">
            Your appointment's 15 minute reservation has expired.
        </div>

        <div class="pt-4 pb-16">
            Would you like to try to reserve the same slot?
        </div>

        <div class="modal-footer">
            <button type="button"
                    role="button"
                    class="btn btn-primary mr-2"
                    :class="{ loading: reservingAppointment }"
                    :disabled="reservingAppointment"
                    @click="sendReserveAppointmentRequest"
            >Reserve again</button>

            <button type="button"
                    role="button"
                    class="btn btn-secondary"
                    :disabled="reservingAppointment"
                    @click="goBack"
            >Go back</button>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'reserve-same-appointment',

        computed: {
            ...mapState('appointment', [
                'appointmentData',
            ]),

            ...mapState('appointments', [
                'reservingAppointment',
                'reservedAppointment',
            ]),
        },

        methods: {
            ...mapActions('appointments', [
                'reserveAppointment',
            ]),

            goBack() {
                this.$router.push({ name: 'home' });
            },

            sendReserveAppointmentRequest() {
                const params = {
                    clinic: {
                        ClinicID: this.appointmentData.clinic.ClinicID,
                        ClinicName: this.appointmentData.clinic.ClinicName,
                        Address1: this.appointmentData.clinic.Address1,
                        Postcode: this.appointmentData.clinic.Postcode,
                        InsideM25: this.appointmentData.clinic.InsideM25,
                        ClinicTier: this.appointmentData.clinic.ClinicTier,
                        Distance: this.appointmentData.clinic.Distance,
                    },
                    therapist: {
                        TherapistID: this.appointmentData.therapist.TherapistID,
                        Name: this.appointmentData.therapist.Name,
                        Gender: this.appointmentData.therapist.Gender,
                    },
                    appointment: {
                        Date: this.appointmentData.appointment.Date,
                        Time: this.appointmentData.appointment.Time,
                        AppointmentLength: this.appointmentData.appointment.AppointmentLength,
                    },
                };

                const callback = () => {
                    this.dispatch('appointment.refreshed');

                    this.hideModal();
                };

                this.reserveAppointment({ params, callback });
            },
        },
    };
</script>
